/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "key-inline-e54de6f8--sprite",
  "use": "key-inline-e54de6f8--sprite-usage",
  "viewBox": "0 0 18.003 10.046",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.003 10.046\" id=\"key-inline-e54de6f8--sprite\"><path d=\"M-118.277,39.236h-7.247a3.1,3.1,0,0,0-.1-.376c-.05-.151-.1-.3-.159-.443-.008-.008-.008-.008-.008-.017-.067-.151-.134-.293-.209-.435a5.052,5.052,0,0,0-2.031-2.031,4.769,4.769,0,0,0-.468-.226c-.008,0-.025-.008-.033-.008a3.959,3.959,0,0,0-.5-.167.767.767,0,0,0-.184-.05,4.735,4.735,0,0,0-1.2-.151,5.37,5.37,0,0,0-1.1.117c-.134.033-.259.067-.393.109-.109.033-.226.075-.334.117a4.9,4.9,0,0,0-.836.426,4.925,4.925,0,0,0-1.571,1.563l.008.008a4.642,4.642,0,0,0-.644,1.563h-.025a4.96,4.96,0,0,0-.125,1.12,4.742,4.742,0,0,0,.125,1.095h.025a4.778,4.778,0,0,0,.644,1.555l-.017.017a4.816,4.816,0,0,0,1.555,1.571l.017-.017a4.976,4.976,0,0,0,1.571.652v.025a4.794,4.794,0,0,0,1.1.125,4.8,4.8,0,0,0,1.1-.125v-.025a4.649,4.649,0,0,0,1.571-.652l.017.017a4.815,4.815,0,0,0,1.554-1.571l-.008-.008a4.578,4.578,0,0,0,.443-.852c.042-.1.076-.2.109-.3.041-.134.075-.268.108-.41h4.756v1.1a.838.838,0,0,0,.836.836h.543a.838.838,0,0,0,.835-.836v-1.1h.276a.838.838,0,0,0,.835-.836v-.543A.838.838,0,0,0-118.277,39.236Zm-10.364,2.875a2.5,2.5,0,0,1-3.544-.008,2.492,2.492,0,0,1-.727-1.763,2.492,2.492,0,0,1,2.5-2.507,2.5,2.5,0,0,1,2.516,2.5A2.5,2.5,0,0,1-128.641,42.111Z\" transform=\"translate(135.444 -35.333)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
